import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=cb29a61e&scoped=true&"
import script from "./confirmPayment.vue?vue&type=script&lang=js&"
export * from "./confirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=cb29a61e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29a61e",
  null
  
)

component.options.__file = "confirmPayment.vue"
export default component.exports